<template>
  <section class="w-full bg-white p-6 ">
    <!-- <h1 class="text-transpurple font-bold text-48 text-center leading-73">
      Cases by States
    </h1> -->
    <div class="flex">
      <DownloadChart
        @click="downloadCanvas('statesChart', 'titleStackedStatesChart')"
      />
    </div>
    <div ref="statesChart">
      <h3 ref="titleStackedStatesChart" class="hidden mt-4 text-lg">
        Corruption Cases By State
      </h3>
      <BarChart
        :width="0"
        :height="height"
        :chart-data="chartdata"
        :options="options"
      />
    </div>
  </section>
</template>

<script>
import BarChart from "./Charts/BarChart";
// import HorizontalBar from "./Charts/HorizontalBar";
import axios from "axios";

export default {
  name: "StackedStatesCases",
  components: {
    BarChart
  },
  props: {
    count: {
      type: Number,
      default: null
    },
    height: {
      type: Number
    }
  },
  data() {
    return {
      state_counts: []
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    },
    on_trial() {
      return this.state_counts.map(a => a.cases_on_trial_count);
    },
    decided() {
      return this.state_counts.map(a => a.cases_decided_count);
    },
    withdrawn() {
      return this.state_counts.map(a => a.cases_withdrawn_count);
    },
    suspended() {
      return this.state_counts.map(a => a.cases_suspended_count);
    },
    names() {
      return this.state_counts.map(a => a.name);
    },
    chartdata() {
      return {
        labels: this.names,
        datasets: [
          {
            label: "On Trial",
            backgroundColor: "#b6142c",
            data: this.on_trial
          },
          {
            label: "Decided",
            backgroundColor: "#339966",
            data: this.decided
          },
          {
            label: "Withdrawn",
            backgroundColor: "#a2b86c",
            data: this.withdrawn
          },
          {
            label: "Suspended",
            backgroundColor: "#e77e4e",
            data: this.suspended
          }
        ]
      };
    },
    options() {
      return {
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                fontSize: "12",
                fontColor: this.$store.state.main.darkMode
                  ? "#718096"
                  : "#777777",
                callback: function(value) {
                  return value;
                }
              },
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                fontSize: "12",
                fontColor: this.$store.state.main.darkMode
                  ? "#718096"
                  : "#777777",
                callback: function(value) {
                  return value;
                }
              },
              gridLines: {
                display: true
              }
            }
          ]
        },
        legend: {
          display: true
        },
        tooltips: {
          enabled: true,
          mode: "single",
          callbacks: {
            label: function(tooltipItems) {
              return tooltipItems.yLabel;
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200
      };
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.getStatesCount();
      }
    }
  },
  mounted() {
    this.getStatesCount();
  },
  methods: {
    getStatesCount() {
      axios
        .get(`${window.host}/api/statescount/${this.count}`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.state_counts = response.data;
          }
        });
    }
  }
};
</script>

<style scoped>
section {
  .svg {
    width: 100vw;
  }
}
</style>
